import { render } from "./ChangePassword.vue?vue&type=template&id=1f5f78f0"
const script = {}

import exportComponent from "/home/runner/work/Solstice-Web/Solstice-Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__